import { Link } from "@tanstack/react-router";
import { ArrowLeft, BookOpen, Clock } from "lucide-react";

interface Article {
  title: string;
  category: string;
  updatedAt: string;
  sections: { heading: string; body: string }[];
}

const articles: Record<string, Article> = {
  terms: {
    title: "이용약관",
    category: "약관 & 정책",
    updatedAt: "2026-01-15",
    sections: [
      {
        heading: "제1조 (목적)",
        body: '이 약관은 모두의오늘(이하 "회사")이 제공하는 데이터랩툴즈(datalab.tools) 서비스의 이용 조건 및 절차, 회사와 이용자의 권리·의무·책임사항을 규정함을 목적으로 합니다.',
      },
      {
        heading: "제2조 (정의)",
        body: '"서비스"란 회사가 제공하는 키워드 분석, 채널 분석, 검색광고 분석, AI 인사이트 등 모든 온라인 서비스를 의미합니다. "이용자"란 이 약관에 따라 서비스를 이용하는 자를 말합니다. "이용권"이란 서비스의 유료 기능을 이용할 수 있는 권한을 의미합니다.',
      },
      {
        heading: "제3조 (약관의 효력)",
        body: "이 약관은 서비스 화면에 게시하거나 기타의 방법으로 이용자에게 공지함으로써 효력이 발생합니다. 회사는 관련 법령을 위배하지 않는 범위에서 이 약관을 개정할 수 있으며, 개정 시 적용일 및 개정사유를 명시하여 최소 7일 전 공지합니다.",
      },
      {
        heading: "제4조 (서비스의 제공)",
        body: "회사는 다음의 서비스를 제공합니다: 키워드 검색량 분석, 검색결과 순위 추적, 채널 건강 진단, 콘텐츠 분석, 검색광고 시뮬레이션, AI 기반 인사이트 분석, 파티 시스템을 통한 커뮤니티 기능. 서비스는 연중무휴, 1일 24시간 제공을 원칙으로 하되, 정기 점검 및 시스템 업데이트를 위해 일시적으로 중단될 수 있습니다.",
      },
      {
        heading: "제5조 (이용권 및 결제)",
        body: "이용자는 스마트스토어를 통해 이용권을 구매할 수 있습니다. 이용권의 종류는 1일, 5일, 30일, 90일, 180일, 345일이며, 각 이용권에 따라 시간당 API 호출 제한이 차등 적용됩니다. 무료 플랜은 시간당 300회 API 호출 제한이 적용되며, AI 기반 분석 기능이 일부 제한됩니다.",
      },
      {
        heading: "제6조 (환불)",
        body: "결제 후 24시간 이내에 API를 10회 미만 사용한 경우 전액 환불이 가능합니다. 그 이후에는 남은 기간에 비례한 부분 환불이 적용됩니다. 환불 요청은 1:1 문의를 통해 처리됩니다.",
      },
    ],
  },
  privacy: {
    title: "개인정보 처리방침",
    category: "약관 & 정책",
    updatedAt: "2026-01-15",
    sections: [
      {
        heading: "1. 수집하는 개인정보 항목",
        body: "회사는 서비스 제공을 위해 다음의 개인정보를 수집합니다: 필수항목 - 이메일 주소, 비밀번호(암호화), 닉네임. 선택항목 - 마케팅 정보 수신 동의 여부. 서비스 이용 과정에서 자동으로 수집되는 정보 - IP 주소, 접속 일시, 서비스 이용 기록, API 호출 기록.",
      },
      {
        heading: "2. 개인정보의 수집 및 이용 목적",
        body: "수집된 개인정보는 다음의 목적으로 이용됩니다: 회원 관리(가입, 인증, 탈퇴), 서비스 제공(이용권 관리, API 호출 관리), 서비스 개선(이용 통계, 오류 분석), 고객 지원(문의 응대, 공지사항 전달).",
      },
      {
        heading: "3. 개인정보의 보유 및 이용 기간",
        body: "회원 탈퇴 시 즉시 파기를 원칙으로 합니다. 다만, 관련 법령에 의해 보존할 필요가 있는 경우 해당 법령에서 정한 기간 동안 보존합니다: 계약 또는 청약철회 등에 관한 기록(5년), 소비자의 불만 또는 분쟁 처리에 관한 기록(3년), 접속에 관한 기록(3개월).",
      },
      {
        heading: "4. 개인정보의 파기",
        body: "회사는 개인정보 보유기간이 경과하거나 처리 목적이 달성된 경우 지체 없이 해당 개인정보를 파기합니다. 전자적 파일 형태의 정보는 복구할 수 없는 방법으로 영구 삭제합니다.",
      },
      {
        heading: "5. 이용자의 권리",
        body: "이용자는 언제든지 자신의 개인정보에 대해 열람, 정정, 삭제, 처리정지를 요구할 수 있습니다. 요청은 마이페이지 또는 1:1 문의를 통해 처리됩니다.",
      },
    ],
  },
  usage: {
    title: "이용권 안내",
    category: "이용권 & 결제",
    updatedAt: "2026-02-01",
    sections: [
      {
        heading: "이용권 종류",
        body: "데이터랩툴즈는 무료 플랜과 6종의 유료 이용권을 제공합니다. 무료(시간당 300회), 1일(300회, 3,300원), 5일(600회, 11,000원), 30일(1,200회, 55,000원), 90일(1,800회, 148,500원), 180일(3,600회, 280,500원), 345일(7,200회, 500,000원). 장기 이용할수록 일일 단가가 저렴합니다.",
      },
      {
        heading: "API 호출 제한",
        body: "각 이용권에 따라 시간당 최대 API 호출 횟수가 적용됩니다. 이 제한은 키워드 조회, 채널 분석, 검색결과 조회, AI 분석 등 모든 API 호출에 동일하게 적용됩니다. 제한을 초과하면 다음 시간까지 대기해야 합니다.",
      },
      {
        heading: "AI 기능 제한",
        body: "무료 플랜에서는 AI 기반 분석 기능(클러스터링, 의도 분석, 컨설팅, 글 구조 제안 등)이 제한됩니다. 유료 이용권을 등록하면 모든 AI 기능을 이용할 수 있습니다.",
      },
      {
        heading: "이용권 등록 방법",
        body: "1) 스마트스토어에서 원하는 이용권을 구매합니다. 2) 구매 후 주문번호를 확인합니다 (결제 주문내역에서 확인 가능). 3) 마이페이지 > 라이선스 관리에서 주문번호를 입력하고 등록합니다. 4) 등록 즉시 이용권이 활성화됩니다.",
      },
      {
        heading: "데이터 내보내기",
        body: "모든 테이블 데이터는 CSV 형식으로 내보내기가 가능합니다. 각 데이터 테이블 상단의 내보내기 버튼을 이용해주세요.",
      },
    ],
  },
  party: {
    title: "파티 시스템 안내",
    category: "파티 시스템",
    updatedAt: "2026-01-20",
    sections: [
      {
        heading: "파티란?",
        body: "파티 시스템은 데이터랩툴즈 사용자들이 서로 연결되어 혜택을 주고받는 커뮤니티 기능입니다. 파티 리더의 초대 링크를 통해 가입하면 15분 무료 체험 혜택을 받을 수 있으며, 파티 리더에게도 보상이 제공됩니다.",
      },
      {
        heading: "파티 가입 방법",
        body: "1) 마이페이지 > 파티 시스템에서 파티 리더의 이메일을 입력합니다. 2) 또는 파티 리더가 공유한 초대 링크를 통해 직접 가입할 수 있습니다. 3) 가입 즉시 15분 무료 체험 혜택이 적용됩니다.",
      },
      {
        heading: "파티 리더 혜택",
        body: "파티 멤버가 이용권을 구매하면 파티 리더에게 보상이 제공됩니다. 보상은 파티 멤버의 활동 수준에 따라 차등 적용되며, 이용권 연장 또는 API 호출 한도 증가 형태로 지급됩니다.",
      },
      {
        heading: "파티 레벨",
        body: "파티 활동에 따라 레벨이 부여됩니다. 레벨이 높을수록 더 많은 혜택을 받을 수 있습니다. 레벨은 파티 멤버 수, 활동 기간, 멤버들의 이용권 구매 실적 등을 종합하여 산정됩니다.",
      },
    ],
  },
  "getting-started": {
    title: "서비스 소개",
    category: "시작하기",
    updatedAt: "2026-03-01",
    sections: [
      {
        heading: "데이터랩툴즈란?",
        body: "데이터랩툴즈(datalab.tools)는 키워드 마케팅에 특화된 빅데이터 분석 솔루션입니다. 42,000개 이상의 키워드를 추적하고, 7개 채널 유형(블로그, 카페, 인플루언서, 스마트플레이스, 뉴스, 동영상, 쇼핑)을 통합 분석하며, 21개 AI 기능으로 전략 수립까지 지원합니다.",
      },
      {
        heading: "주요 기능",
        body: "키워드 분석(검색량, 경쟁도, 트렌드), 검색결과 분석(채널별 순위, 노출 분석), 채널 분석(건강 진단, 품질 점수), 콘텐츠 분석(본문 분석, SEO 점수), 검색광고 분석(입찰가, ROI 시뮬레이션), 모니터링(순위 추적, 저품질 탐지, 알림), AI 비서(클러스터링, 의도 분석, 글 구조 제안, 채널 컨설팅).",
      },
      {
        heading: "시작하는 방법",
        body: "1) 회원가입 후 이메일 인증을 완료합니다. 2) 무료 플랜으로 기본 기능을 체험합니다. 3) 키워드를 등록하면 자동으로 데이터 수집이 시작됩니다. 4) 대시보드에서 분석 결과를 확인하고 전략을 수립합니다. 더 많은 기능이 필요하면 이용권을 구매하세요.",
      },
      {
        heading: "SOLA Codex 알고리즘",
        body: "데이터랩툴즈만의 독자적인 품질 평가 알고리즘입니다. 전문성, 신뢰성, 최신성, 사용자 참여도 등을 종합하여 0~100점 사이의 품질 점수를 산출합니다. 이 점수를 통해 채널의 건강 상태를 객관적으로 진단하고, 개선 방향을 파악할 수 있습니다.",
      },
    ],
  },
  account: {
    title: "회원가입 & 로그인",
    category: "시작하기",
    updatedAt: "2026-02-15",
    sections: [
      {
        heading: "회원가입",
        body: "이메일과 비밀번호를 입력하여 간편하게 회원가입할 수 있습니다. 이용약관과 개인정보 처리방침에 동의가 필요합니다. 가입 후 이메일 인증을 완료하면 모든 기능을 이용할 수 있습니다.",
      },
      {
        heading: "소셜 로그인",
        body: "소셜 계정으로 간편 로그인할 수 있습니다. 소셜 로그인을 이용하면 별도의 비밀번호 설정 없이 바로 서비스를 이용할 수 있습니다. (현재 준비 중)",
      },
      {
        heading: "비밀번호 찾기",
        body: "비밀번호를 잊은 경우, 가입 시 사용한 이메일로 비밀번호 재설정 링크를 받을 수 있습니다. 링크를 클릭하면 새로운 비밀번호를 설정할 수 있습니다.",
      },
      {
        heading: "이메일 인증",
        body: "가입 후 등록한 이메일로 6자리 인증 코드가 발송됩니다. 코드를 입력하면 인증이 완료됩니다. 인증을 완료하지 않으면 일부 기능이 제한될 수 있습니다.",
      },
    ],
  },
};

const fallbackArticle: Article = {
  title: "페이지 준비 중",
  category: "도움말",
  updatedAt: new Date().toISOString().slice(0, 10),
  sections: [
    {
      heading: "준비 중입니다",
      body: "이 도움말 페이지는 현재 작성 중입니다. 빠른 시일 내에 업데이트하겠습니다. 궁금한 점은 1:1 문의(https://modoo.today/talk)를 이용해주세요.",
    },
  ],
};

export function HelpArticlePage(props: { slug?: string }) {
  const article = articles[props.slug ?? ""] ?? fallbackArticle;
  const docsTo = "/docs";

  return (
    <div className="mx-auto max-w-3xl">
      <div className="mb-4 flex items-center gap-1.5 text-[12px] text-text-tertiary">
        <Link to={docsTo} className="hover:text-text-primary">
          도움말
        </Link>
        <span>/</span>
        <span className="font-medium text-text-primary">{article.category}</span>
      </div>

      <div className="mb-6">
        <h1 className="text-xl font-bold">{article.title}</h1>
        <div className="mt-2 flex items-center gap-3 text-[11px] text-text-tertiary">
          <span className="flex items-center gap-1">
            <BookOpen className="size-3" /> {article.category}
          </span>
          <span className="flex items-center gap-1">
            <Clock className="size-3" /> 최종 수정: {article.updatedAt}
          </span>
        </div>
      </div>

      <div className="space-y-6 rounded-xl border border-stroke-subtle bg-surface-raised p-6 lg:p-8">
        {article.sections.map((section, index) => (
          <div key={index}>
            <h2 className="mb-2 text-[15px] font-bold">{section.heading}</h2>
            <p className="text-[13px] leading-[1.9] text-text-tertiary">
              {section.body}
            </p>
            {index < article.sections.length - 1 && (
              <div className="mt-6 border-t border-stroke-subtle" />
            )}
          </div>
        ))}
      </div>

      <div className="mt-6 flex items-center justify-between">
        <Link
          to={docsTo}
          className="inline-flex items-center gap-1.5 text-[13px] font-medium text-text-brand hover:underline"
        >
          <ArrowLeft className="size-3.5" /> 도움말 목록
        </Link>
        <a
          href="https://modoo.today/talk"
          target="_blank"
          rel="noopener noreferrer"
          className="text-[12px] text-text-tertiary hover:text-text-primary"
        >
          이 문서가 도움이 되지 않았나요? 1:1 문의하기
        </a>
      </div>
    </div>
  );
}
